import { pmoInstance } from "config";
import { getHeader } from "config";

/**
 * To create Stories
 * body={
   "students": [
   "d2b4b8c7-02d2-4757-9ae4-77b854001846",
   "7df85d43-38ff-4a8b-9824-297c896ec1e6"
   ],
   "stories": {
   "title": "test2",
   "due_date": "2022-01-20T19:27:26.000Z",
   "status": "NotStarted",
   "project_id":"2fc2bde3-a859-4343-aa02-616e2c94e9d3",
   "owner_id" : "d2b4b8c7-02d2-4757-9ae4-77b854001846"
}}
 */
export const createStories = (body) =>
  pmoInstance.post(`/story`, body, getHeader());

/**
 * To delete Stories
 * @param id --> id of Stories
 */
export const deleteStories = (id) =>
  pmoInstance.delete(`/story/${id}`, getHeader());

/**
 * To get all Stories
 * @param type --> Stories
 */
export const getAllStories = (query) =>
  pmoInstance.get(
    `/story${
      query && Object.keys(query).length > 0
        ? `?${new URLSearchParams(query)}`
        : ""
    }`,
    getHeader()
  );

/**
 * Gives a Stories
 * @param id --> id of Stories
 */
export const getStoriesById = (id, query) =>
  pmoInstance.get(
    `/story/${id}${
      query && Object.keys(query).length > 0
        ? `?${new URLSearchParams(query)}`
        : ""
    }`,
    getHeader()
  );

/**
 * To update Stories
 * @param id --> id of Stories
 */
export const updateStories = (id, body) =>
  pmoInstance.patch(`/story/${id}`, body, getHeader());
